import { Component, Vue } from 'vue-property-decorator';
import { getExecutionStepFromPath } from '@/services/helpers';

@Component
export default class Stepper extends Vue {
  public get executionStep() {
    return getExecutionStepFromPath(this.$route.path);
  }

  public get executionProgress(): number {
    return this.executionStep * 34; // get progress percentage 1 = 34% | 2 = 68% | 3 = 102%
  }
}
